export const updateError = (errorInfo, dispatch) => {
  dispatch({
    type: 'TRIGGER_ERROR',
    payload: errorInfo,
  });
};

export const clearError = (dispatch) => dispatch({ type: 'CLEAR_ERROR' });

export const updateSelectedTickets = (selectedTicketsArray, dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_TICKETS',
    payload: selectedTicketsArray,
  });

export const updateFilteredTicketIds = (filteredTickets, dispatch) =>
  dispatch({
    type: 'UPDATE_FILTERED_TICKET_IDS',
    payload: filteredTickets,
  });

export const updateDivision = (division, dispatch) =>
  dispatch({
    type: 'UPDATE_DIVISION',
    payload: division,
  });

export const updateFolder = (folder, dispatch) =>
  dispatch({
    type: 'UPDATE_FOLDER',
    payload: folder,
  });

export const updateSortedDocs = (sortOrder, dispatch) =>
  dispatch({
    type: 'UPDATE_SORTED_DOCS',
    payload: sortOrder,
  });

export const updateSortCriterion = (sortCriterion, dispatch) =>
  dispatch({
    type: 'UPDATE_SORT_CRITERION',
    payload: sortCriterion,
  });

export const updateSelectedCell = (selectedCell, dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_CELL',
    payload: selectedCell,
  });

export const updateTicketDetail = (ticketInfo, dispatch) =>
  dispatch({
    type: 'LOAD_TICKET_DETAIL',
    payload: ticketInfo,
  });

export const updateFiltersArray = (updatedArray, dispatch) =>
  dispatch({
    type: 'UPDATE_FILTERS_ARRAY',
    payload: updatedArray,
  });

export const updateDivisionOptions = (divisionOptions, dispatch) =>
  dispatch({
    type: 'UPDATE_DIVISION_OPTIONS',
    payload: divisionOptions,
  });

export const updateFolderOptions = (folderOptions, dispatch) =>
  dispatch({
    type: 'UPDATE_FOLDER_OPTIONS',
    payload: folderOptions,
  });

export const updateFetchedFolders = (fetchedFoldersObj, dispatch) =>
  dispatch({
    type: 'UPDATE_FETCHED_FOLDERS',
    payload: fetchedFoldersObj,
  });

export const updateViewComponent = (viewComponent, dispatch) =>
  dispatch({
    type: 'UPDATE_MAP_VIEW',
    payload: viewComponent,
  });

export const updateMapExtent = (newExtent, dispatch) =>
  dispatch({
    type: 'UPDATE_MAP_EXTENT',
    payload: newExtent,
  });

export const updateMapZoom = (newZoom, dispatch) =>
  dispatch({
    type: 'UPDATE_MAP_ZOOM',
    payload: newZoom,
  });

export const updateModalResponseType = (modalResponseType, dispatch) =>
  dispatch({
    type: 'UPDATE_MODAL_RESPONSE_TYPE',
    payload: modalResponseType,
  });

export const updateSelectedMatch = (newMatch, dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_MATCH',
    payload: newMatch,
  });

export const updateUnitType = (unitType, dispatch) =>
  dispatch({
    type: 'UPDATE_UNIT_TYPE',
    payload: unitType,
  });

export const updateTicketGroupLabel = (ticketGroupLabel, dispatch) =>
  dispatch({
    type: 'UPDATE_TICKET_GROUP_LABEL',
    payload: ticketGroupLabel,
  });

export const setFoldersJson = (folders, dispatch) =>
  dispatch({
    type: 'LOAD_FOLDERS_JSON_SUCCESS',
    payload: folders,
  });

export const updateAllDocs = (array, dispatch) =>
  dispatch({
    type: 'LOAD_DOCS_SUCCESS',
    payload: array,
  });

export const updateTicketLogs = (ticketLogsObj, dispatch) =>
  dispatch({
    type: 'LOAD_TICKET_LOGS',
    payload: ticketLogsObj,
  });

export const updateMatchingTickets = (matchingTicketsObj, dispatch) =>
  dispatch({
    type: 'LOAD_MATCHING_TICKETS',
    payload: matchingTicketsObj,
  });

export const updateFilteredClosedTodayArray = (ticketArray, dispatch) =>
  dispatch({
    type: 'UPDATE_FILTERED_CLOSED_TODAY_ARRAY',
    payload: ticketArray,
  });

export const updateSelectedCellOpenTickets = (ticketArray, dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_CELL_OPEN_TICKETS',
    payload: ticketArray,
  });

export const updateSelectedCellClosedTickets = (ticketArray, dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_CELL_CLOSED_TICKETS',
    payload: ticketArray,
  });

export const updateSearchInput = (searchInput, dispatch) =>
  dispatch({
    type: 'UPDATE_SEARCH_INPUT',
    payload: searchInput,
  });

export const updateSearchValue = (searchValue, dispatch) =>
  dispatch({
    type: 'UPDATE_SEARCH_VALUE',
    payload: searchValue,
  });

export const updateSearchResults = (searchResults, dispatch) =>
  dispatch({
    type: 'UPDATE_SEARCH_RESULTS',
    payload: searchResults,
  });

export const updateSelectedCity = (selectedCity, dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_CITY',
    payload: selectedCity,
  });

export const updateFromDueDate = (fromDueDate, dispatch) =>
  dispatch({
    type: 'UPDATE_FROM_DUEDATE',
    payload: fromDueDate,
  });

export const updateToDueDate = (toDueDate, dispatch) =>
  dispatch({
    type: 'UPDATE_TO_DUEDATE',
    payload: toDueDate,
  });

export const updateSelectedTicketResponseType = (filterType, dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_TICKET_RESPONSE_TYPE',
    payload: filterType,
  });

export const updateSelectedTicketStatus = (selectedTicketStatus, dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_TICKET_STATUS',
    payload: selectedTicketStatus,
  });

export const updateSelectedLanID = (selectedLanID, dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_LAN_ID',
    payload: selectedLanID,
  });

export const updateSelectedPriority = (selectedPriority, dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_PRIORITY',
    payload: selectedPriority,
  });

export const updateSelectedDigIn = (selectedDigIn, dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_DIGIN',
    payload: selectedDigIn,
  });

export const updateFoldersLoaded = (foldersLoaded, dispatch) =>
  dispatch({
    type: 'UPDATE_FOLDERS_LOADED',
    payload: foldersLoaded,
  });

export const updateDocPins = (docPins, dispatch) =>
  dispatch({
    type: 'UPDATE_DOCPINS',
    payload: docPins,
  });

export const updateRegCodesList = (regCodesList, dispatch) =>
  dispatch({
    type: 'UPDATE_REG_CODES_LIST',
    payload: regCodesList,
  });

export const updateAccess = (access, dispatch) =>
  dispatch({
    type: 'UPDATE_ACCESS',
    payload: access,
  });
export const updatePermissions = (permissions, dispatch) =>
  dispatch({
    type: 'UPDATE_PERMISSIONS',
    payload: permissions,
  });
export const updateRoles = (roles, dispatch) =>
  dispatch({
    type: 'UPDATE_ROLES',
    payload: roles,
  });
export const updateToggledDocTypes = (toggledDocTypes, dispatch) =>
  dispatch({
    type: 'UPDATE_TOGGLED_DOCTYPES',
    payload: toggledDocTypes,
  });
            